import { Store } from "vuex";

export interface RootState {
    filterIsOpen: boolean;
    filterIsChanged: boolean;
    filterIsClean: boolean;
}

const store = new Store<RootState>({
    state: {
        filterIsOpen: false,
        filterIsChanged: false,
        filterIsClean: true,
    },

    mutations: {
        changeFilterOpen(state, payload) {
            state.filterIsOpen = payload;
        },
        changeFilterState(state, payload) {
            state.filterIsChanged = payload;
        },
        changeFilterClean(state, payload) {
            state.filterIsClean = payload;
        },
    },
    actions: {
        actionChangeFilterOpen({ commit }, payload) {
            commit("changeFilterOpen", payload);
        },
        actionChangeFilterState({ commit }, payload) {
            commit("changeFilterState", payload);
        },
        actionChangeFilterClean({ commit }, payload) {
            commit("changeFilterClean", payload);
        },
    },
    getters: {
        getFilterOpen(state) {
            return state.filterIsOpen;
        },
        getFilterChanged(state) {
            return state.filterIsChanged;
        },
        getFilterClean(state) {
            return state.filterIsClean;
        },
    },
});

export default store;

export function useStore() {
    return store as Store<RootState>;
}
